import { fetchWithValidation } from '../services/AppSettingsService';

// Store the original fetch globally so it can be accessed by fetchWithValidation
let originalFetch: typeof fetch;

// Flag to track if the interceptor has been initialized
let isInterceptorInitialized = false;

// Replace the global fetch with our validated fetch
export function setupFetchInterceptor() {
  // Only initialize once - make it idempotent
  if (isInterceptorInitialized) {
    return;
  }

  // Store the original fetch only the first time
  originalFetch = window.fetch;
  isInterceptorInitialized = true;

  // Replace with our validated fetch
  window.fetch = async function(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    return fetchWithValidation(input, init);
  };

  // Return a function to restore the original fetch if needed
  return function restoreOriginalFetch() {
    window.fetch = originalFetch;
    isInterceptorInitialized = false;
  };
}

// Export the original fetch for use in fetchWithValidation
export function getOriginalFetch(): typeof fetch {
  return originalFetch || window.fetch;
}

// // Export a function to get the validated fetch
// export function getValidatedFetch() {
//   return fetchWithValidation;
// }

// Function to add auth token to request headers
export async function fetchWithAuth(input: RequestInfo | URL, init?: RequestInit, token?: string): Promise<Response> {
  // Create a new init object to avoid modifying the original
  const newInit = init ? { ...init } : {};

  // Add the token to the headers if available
  if (token) {
    newInit.headers = {
      ...newInit.headers,
      'Authorization': `Bearer ${token}`
    };
  }

  // Use the validated fetch with the new init
  return fetchWithValidation(input, newInit);
}

// Initialize the fetch interceptor immediately when this module is imported, this ensures all fetch calls (including those on first page render) go through the interceptor
setupFetchInterceptor();
